import { FC } from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import './App.css';
import ConditionOrder from './ConditionOrder';
import DCA from './DCA';
import DefaultRedirect from './DefaultRedirect';
import MultiOrder from './MultiOrder';
import SenseIAA from './SenseIAA';
import SetPrivacy from './SetPrivacy';
import StockScreener from './StockScreener';
import Streaming from './Streaming';
import ESGInfo from './ESGInfo';
import StockInfo from './StockInfo';
import DRxInfo from './DRxInfo';

const App: FC = () => {
  return (
    <BrowserRouter basename='settrade-website-redirect'>
      <Routes>
        <Route path='streaming' element={<Streaming />}></Route>
        <Route path='condition-order' element={<ConditionOrder />}></Route>
        <Route path='multi-order' element={<MultiOrder />}></Route>
        <Route path='stock-screener' element={<StockScreener />}></Route>
        <Route path='dca' element={<DCA />}></Route>
        <Route path='sense-iaa/:symbol' element={<SenseIAA />}></Route>
        <Route path='set-privacy' element={<SetPrivacy />}></Route>
        <Route path='set-privacy/:lang' element={<SetPrivacy />}></Route>
        <Route path='equities/esg-info/:symbol' element={<ESGInfo />}></Route>
        <Route path='equities/stock-info/:symbol' element={<StockInfo />}></Route>
        <Route path='drx/stock-info/:symbol' element={<DRxInfo />}></Route>
        <Route path='*' element={<DefaultRedirect />}></Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
